var _excluded = ["size", "className", "onClear", "allowClear"],
  _excluded2 = ["size", "className", "onClear", "allowClear"],
  _excluded3 = ["size", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import { CloseFilled, EyeInvisibleOutlined, EyeOutlined } from '@aelf-design/icons';
import { Input as AntdInput } from 'antd';
import { useTheme } from 'antd-style';
import useStyles from "./style";
var getClearIcon = function getClearIcon(onClear, token) {
  var _token$Table;
  return /*#__PURE__*/React.createElement("div", {
    onClick: function onClick(e) {
      onClear === null || onClear === void 0 || onClear(e);
    }
  }, /*#__PURE__*/React.createElement(CloseFilled, {
    color: token === null || token === void 0 ? void 0 : token.colorBorder,
    hoverColor: token === null || token === void 0 || (_token$Table = token.Table) === null || _token$Table === void 0 ? void 0 : _token$Table.headerBg,
    activeColor: token === null || token === void 0 ? void 0 : token.colorTextDisabled
  }));
};
var InternalInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'middle' : _ref$size,
    className = _ref.className,
    onClear = _ref.onClear,
    allowClear = _ref.allowClear,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles({
      size: size
    }),
    st = _useStyles.styles;
  var token = useTheme();
  return /*#__PURE__*/React.createElement(AntdInput, _extends({}, rest, {
    ref: ref,
    size: size,
    className: "".concat(st.aelfdInput, " ").concat(className || ''),
    allowClear: allowClear === false ? false : allowClear ? allowClear : {
      clearIcon: getClearIcon(onClear, token)
    }
  }));
});
function InputPassword(_ref2) {
  var _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'middle' : _ref2$size,
    className = _ref2.className,
    onClear = _ref2.onClear,
    allowClear = _ref2.allowClear,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  var _useStyles2 = useStyles({
      size: size
    }),
    st = _useStyles2.styles;
  var token = useTheme();
  var iconProps = {
    twoToneColor: [token === null || token === void 0 ? void 0 : token.colorBorder, token === null || token === void 0 ? void 0 : token.colorBorder],
    hoverTwoToneColor: [token === null || token === void 0 ? void 0 : token.colorPrimaryHover, token === null || token === void 0 ? void 0 : token.colorPrimaryHover],
    activeTwoToneColor: [token === null || token === void 0 ? void 0 : token.colorPrimaryActive, token === null || token === void 0 ? void 0 : token.colorPrimaryActive]
  };
  return /*#__PURE__*/React.createElement(AntdInput.Password, _extends({}, rest, {
    size: size,
    className: "".concat(st.aelfdInput, " ").concat(className || ''),
    allowClear: allowClear === false ? false : allowClear ? allowClear : {
      clearIcon: getClearIcon(onClear, token)
    },
    iconRender: function iconRender(visible) {
      return visible ? /*#__PURE__*/React.createElement(EyeInvisibleOutlined, iconProps) : /*#__PURE__*/React.createElement(EyeOutlined, iconProps);
    }
  }));
}
function InputTextArea(_ref3) {
  var _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 'middle' : _ref3$size,
    className = _ref3.className,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  var _useStyles3 = useStyles({
      size: size
    }),
    st = _useStyles3.styles;
  return /*#__PURE__*/React.createElement(AntdInput.TextArea, _extends({}, rest, {
    size: size,
    className: "".concat(st.aelfdInput, " ").concat(className || '')
  }));
}
if (process.env.NODE_ENV !== 'production') {
  InternalInput.displayName = 'Input';
}
var Input = InternalInput;
Input.Password = InputPassword;
Input.TextArea = InputTextArea;
export default Input;